import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'
import type { Pod } from '@/types/pod'

export const usePodsStore = defineStore('pods', () => {
  const pods = ref<Pod[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  async function fetchPods() {
    isLoading.value = true
    error.value = null
    try {
      const response = await api.get(API_ROUTES.CAMPUS_GUIDE_PODS)
      pods.value = response.data
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch pods'
      pods.value = []
      console.error('Error fetching pods:', err)
    } finally {
      isLoading.value = false
    }
  }

  async function createPod(payload: {
    name: string
    start_date: string
    details?: string
    first_meeting_date?: string | null
    fellow_ids?: number[]
    guide_ids?: number[]
    main_guide_id?: number | null
    resume_mentor_id?: number | null
    behavioral_mentor_id?: number | null
  }) {
    isLoading.value = true
    error.value = null
    try {
      const response = await api.post(API_ROUTES.CREATE_POD, payload, { timeout: 120000 })
      pods.value = [response.data, ...pods.value]
      return response.data
    } catch (err: any) {
      error.value = err.response?.data?.message || err.response?.data?.error || 'Failed to create pod'
      throw err
    } finally {
      isLoading.value = false
    }
  }

  return {
    pods,
    isLoading,
    error,
    fetchPods,
    createPod,
  }
})
